import { buildPaymentPayload } from '../../hooks/usePayment/buildPaymentPayload';

export const buildGooglePayData = (unformattedData: string, installments: number | null, merchantInfo?: string) => {
  const googleToken = JSON.parse(
    unformattedData
  );

  const installment = installments && installments > 0 ? installments : 1

  return buildPaymentPayload('google_pay', {
    details: {
      google_pay: {
        signature: googleToken.signature,
        intermediate_signing_key: {
          signed_key: googleToken.intermediateSigningKey.signedKey,
          signatures: googleToken.intermediateSigningKey.signatures,
        },
        version: googleToken.protocolVersion,
        signed_message: googleToken.signedMessage,
        merchant_identifier: merchantInfo,
        installments: installment,
      },
    },
  });
}
